export const getFormSchemaData = (schema, data) => {
    // Get the schema fields (keys)
    const schemaKeys = Object.keys(schema.fields);
    // Filter data to include only schema keys
    const filteredValues = schemaKeys.reduce((obj, key) => {
        if (key in data) {
            // @ts-ignore
            const fieldType = schema.fields[key]?.type;
            const defaultValue = fieldType === "array" ? [] : "";
            obj[key] = data[key] || defaultValue;
        }
        return obj;
    }, {});
    return filteredValues;
};
export const typeAsUUID = (str = "") => {
    if (typeof str === "string") {
        return str;
    }
    return "";
};
/**
 * Utility functions for form handling
 */
/**
 * Handles number input changes and converts empty strings to null
 * @param value - The input value from the number input
 * @param form - The form instance (Mantine useForm)
 * @param fieldPath - The field path to update
 */
export const handleNumberInputChange = (value, form, fieldPath) => {
    const numericValue = value === "" ? null : value;
    form.setFieldValue(fieldPath, numericValue);
};
/**
 * Handles number input changes and converts empty strings to null, with number conversion
 * @param value - The input value from the number input
 * @param form - The form instance (Mantine useForm)
 * @param fieldPath - The field path to update
 * @param convertToNumber - Whether to convert the value to a number (default: false)
 */
export const handleNumberInputChangeWithConversion = (value, form, fieldPath, convertToNumber = false) => {
    let finalValue = value === "" ? null : value;
    if (convertToNumber && finalValue !== null) {
        finalValue = Number(finalValue);
    }
    form.setFieldValue(fieldPath, finalValue);
};
/**
 * Handles numeric input changes, filtering out all non-numeric characters (0-9 only)
 * @param value - The input value from the text input
 * @param form - The form instance (Mantine useForm)
 * @param fieldPath - The field path to update
 */
export const handleNumericOnlyInputChange = (value, form, fieldPath) => {
    // Filter out all non-numeric characters, keeping only 0-9
    const numericOnlyValue = value.replace(/[^0-9]/g, "");
    const finalValue = numericOnlyValue === "" ? null : numericOnlyValue;
    form.setFieldValue(fieldPath, finalValue);
};
